import React from 'react';
// import "../app.css"// Import your CSS file
import "./About1.css"
import img8 from "../components/pages/Image/logo.png"

export function About1() {
  return (
    <section class="about-section">
    <div class="container">
        <div class="row">                
            <div class="content-column col-lg-6 col-md-12 col-sm-12 order-2">
                <div class="inner-column">
                    <div class="sec-title text-white">
                   
                        <h2 className='text-white pt-5 mt-4'>Who we are?</h2>
                    </div>
                    <div class="text text-white">Japland Tours And Safaris Uganda</div>
                  <div class="text text-white">
                  Japland Tours and Safaris Uganda embodies a deep passion for showcasing the beauty, diversity, and adventure of Uganda and East Africa. Our foundation is rooted in a genuine desire to bring the world closer to the wonders of this region. Drawing on extensive experience in the hospitality industry, including positions with renowned luxury hotel brands worldwide, we bring a wealth of expertise to ensure personalized service tailored to your needs and preferences.

                  </div>
                  <div class="text text-white">
                  Uganda boasts a rich tapestry of distinctive cultures, abundant wildlife safaris, diverse flora and fauna, as well as delightful weather and cuisine. We take pride in upholding the highest standards of integrity and customer service to provide you with an unforgettable travel experience.

                  </div>
                  <div class="text text-white">
                  
Our dedicated mission is to lead you on an extraordinary adventure filled with moments that will resonate long after you have returned home. With our team of highly experienced and qualified professionals, we are committed to delivering exceptional service and creating memories that will last a lifetime. 
                  </div>
                    <div class="btn-box text-white">
                        <a href="https://wa.me/+971551579904" class="theme-btn btn-style-one">Contact</a>
                    </div>
                </div>
            </div>

          
            <div class="image-column col-lg-6 col-md-12 col-sm-12">
                <div class="inner-column wow fadeInLeft">
                  {/* <div class="author-desc">
                    <h2>Rahul Kumar Yadav</h2>
                    <span>Web Developer</span>
                  </div> */}
                    <figure class="image-1"><a href="https://wa.me/+971551579904" class="lightbox-image" data-fancybox="images"><img title="japland tours" src={img8} alt="japland tours" className='col-12 bg-white'/></a></figure>
                 
                </div>
            </div>
          
        </div>
       <div class="sec-title">
                        <span class="title text-white">    </span>
                        <h2 className='text-white mt-5 pt-3'>   Our Mission</h2>
                    </div>
      {/* <div class="text text-white">
            We works on UI/UX and functionality as well so that a plugins comes with proper stucture & stunning looks which suits to your web app & website.
          </div>
           <div class="text text-white" >
            We take a small toolkit here and ride it well so that it is fit for your use. One who performs well and looks even better.
          </div> 
           <div class="text text-white">                
           Our mission is to take you through an adventure that promises moments that linger long after you return home, passed to you by our very experienced and qualified team.
          </div>
           {/* <div class="text text-white">
            Here you can also share the content you create, if our technical team likes it, then we will also share it on our blog.
          </div> */}
           <div class="text text-white">
            
In the end, I would say keep visiting our website and enjoy the quality content.
          </div>
    </div>
</section>
  );
}



